import { useMemo, type ReactNode } from 'react'
import {
  type OwnerRole,
  type OwnerCapability,
  type RolesContextValue,
  ROLE_CAPABILITIES,
  RolesContext,
} from './RolesContext'

export type { OwnerRole, OwnerCapability, RolesContextValue }

export function RolesProvider({
  role = 'founder',
  children,
}: {
  role?: OwnerRole
  children: ReactNode
}) {
  const value = useMemo<RolesContextValue>(() => {
    const caps = ROLE_CAPABILITIES[role] || ROLE_CAPABILITIES.founder
    return {
      role,
      can: (cap: OwnerCapability) => caps.has(cap),
    }
  }, [role])

  return <RolesContext.Provider value={value}>{children}</RolesContext.Provider>
}

